import { render, staticRenderFns } from "./FileModal.vue?vue&type=template&id=58030a31&scoped=true&class=pt-0&"
import script from "./FileModal.vue?vue&type=script&lang=js&"
export * from "./FileModal.vue?vue&type=script&lang=js&"
import style0 from "./FileModal.vue?vue&type=style&index=0&id=58030a31&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58030a31",
  null
  
)

export default component.exports